import { useEffect, useReducer, useRef } from 'react';
import { midi } from '@/lib/midi';

export function useMidiState() {
  const [, force] = useReducer((x) => x + 1, 0);
  useEffect(() => midi.subscribe(force), []);
  return midi;
}

// Connects a page's transport to MIDI in/out.
export function useMidiTransport({ isPlaying, togglePlay, setBpm, getBpm }) {
  const ref = useRef();
  ref.current = { isPlaying, togglePlay, setBpm, getBpm };

  useEffect(() => {
    const handler = {
      toggle: () => ref.current.togglePlay(),
      isPlaying: () => ref.current.isPlaying,
      setBpm: (b) => ref.current.setBpm(b),
      getBpm: () => ref.current.getBpm(),
    };
    midi.transport = handler;
    return () => {
      if (midi.transport === handler) midi.transport = null;
      if (midi.playing) midi.notifyPlay(false);
    };
  }, []);

  useEffect(() => {
    if (!!midi.playing !== isPlaying) midi.notifyPlay(isPlaying);
  }, [isPlaying]);
}
